import jsPDF from 'jspdf';

export async function exportOrdenHospitalizacionPDF({ paciente, orden, doctor, imprimir = false }) {
  const doc = new jsPDF({ unit: 'pt', format: 'letter' });
  const pw = doc.internal.pageSize.getWidth();
  const ph = doc.internal.pageSize.getHeight();
  const m = 28;
  let y = m;

  const hoy = new Date().toLocaleDateString('es', { day: '2-digit', month: '2-digit', year: 'numeric' });

  const calcEdad = (iso) => {
    if (!iso) return '—';
    const dob = new Date(iso);
    return Math.floor((Date.now() - dob.getTime()) / (365.25 * 24 * 3600 * 1000));
  };
  const fmtFechaNac = (iso) => {
    if (!iso) return '';
    return new Date(iso).toLocaleDateString('es', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  const edad = calcEdad(paciente?.fecha_nacimiento);
  const fechaNac = fmtFechaNac(paciente?.fecha_nacimiento);
  const nombrePaciente = (paciente?.nombre_completo || '—').toUpperCase();

  // Datos del doctor (hardcodeados por ahora — luego vendrán de BD)
  const dr = {
    nombre: doctor?.nombre || 'Raul Olier',
    rfc: doctor?.rfc || 'OIPH650912881',
    especialidad1: doctor?.especialidad1 || 'Medicina General',
    cedula: doctor?.cedula || '3625181',
    universidad: doctor?.universidad || 'Universidad de Cartagena - Colombia',
    especialidad2: doctor?.especialidad2 || 'Maestría en Cirugía Estética',
    dgp: doctor?.dgp || '6698688',
  };

  // ── Cargar imágenes ──
  let logoImg = null;
  let firmaImg = null;
  try {
    const toDataUrl = (url) => new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        const c = document.createElement('canvas');
        c.width = img.width; c.height = img.height;
        c.getContext('2d').drawImage(img, 0, 0);
        resolve(c.toDataURL('image/png'));
      };
      img.onerror = () => resolve(null);
      img.src = url;
    });
    logoImg = await toDataUrl('/logo-nara-png.png');
    firmaImg = await toDataUrl('/firma_doctor.png');
  } catch (e) { /* sin imágenes */ }

  // ── Logo arriba-izquierda ──
  if (logoImg) {
    doc.addImage(logoImg, 'PNG', 10, 8, 65, 65);
  }

  // ── Título + fecha arriba-derecha ──
  const headerX = logoImg ? 80 : m;
  doc.setFontSize(8);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 0);
  doc.text('ORDEN DE HOSPITALIZACIÓN', headerX, m + 20);

  doc.setFontSize(8.5);
  doc.setTextColor(112, 112, 112);
  doc.setFont('helvetica', 'bold');
  doc.text('FECHA DE IMPRESIÓN:', headerX + 200, m + 20);
  doc.setTextColor(0, 0, 0);
  doc.text(` ${hoy}`, headerX + 200 + doc.getTextWidth('FECHA DE IMPRESIÓN:'), m + 20);

  // ── Datos del doctor ──
  y = m + 50;
  const labelVal = (label, val, yPos, xPos = m) => {
    doc.setTextColor(112, 112, 112);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8.5);
    doc.text(label, xPos, yPos);
    doc.setTextColor(0, 0, 0);
    const lines = doc.splitTextToSize(val, pw - xPos - m - doc.getTextWidth(label) - 4);
    doc.text(lines, xPos + doc.getTextWidth(label) + 4, yPos);
    return yPos + (lines.length * 11) + 2;
  };

  y = labelVal('Dr. ', dr.nombre, y);
  y = labelVal('RFC: ', dr.rfc, y);
  y = labelVal('Especialidad: ', `${dr.especialidad1}  Cédula: ${dr.cedula}  ${dr.universidad}`, y);
  y = labelVal('Especialidad: ', dr.especialidad2, y);
  y = labelVal('D.G.P. ', dr.dgp, y);

  y += 5;

  // ── Línea separadora ──
  doc.setDrawColor(180, 180, 180);
  doc.setLineWidth(0.5);
  doc.line(m, y, pw - m, y);
  y += 12;

  // ── Labels paciente ──
  doc.setFontSize(8.5);
  doc.setTextColor(112, 112, 112);
  doc.setFont('helvetica', 'bold');
  doc.text('Nombre del paciente', m, y);
  doc.text('Edad', pw / 2 + 40, y);
  y += 14;

  // ── Valores paciente ──
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica', 'bold');
  doc.text(nombrePaciente, m + 4, y);
  doc.setFontSize(8.5);
  doc.text(`${edad} años${fechaNac ? ` (${fechaNac})` : ''}`, pw / 2 + 40, y);
  y += 18;

  // ── Línea separadora ──
  doc.setDrawColor(200, 200, 200);
  doc.setLineWidth(0.3);
  doc.line(m, y, pw - m, y);
  y += 15;

  // ── Cuerpo ──
  const contenido = orden?.contenido || {};

  // "Favor de hospitalizar a:"
  doc.setFontSize(8.5);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 0);
  doc.text(`Favor de hospitalizar a: ${nombrePaciente}`, m, y);
  y += 18;

  // Indicaciones hospitalarias
  if (contenido.indicaciones_hospitalarias) {
    doc.setFontSize(8.5);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(112, 112, 112);
    doc.text('Indicaciones hospitalarias:', m, y);
    y += 12;
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
    const lines = doc.splitTextToSize(contenido.indicaciones_hospitalarias, pw - m * 2);
    for (const line of lines) {
      if (y > ph - 80) { doc.addPage(); y = m; }
      doc.text(line, m, y);
      y += 11;
    }
    y += 8;
  }

  // Indicaciones para el paciente
  if (contenido.indicaciones_paciente) {
    doc.setFontSize(8.5);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(112, 112, 112);
    doc.text('Indicaciones para el paciente:', m, y);
    y += 12;
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
    const lines = doc.splitTextToSize(contenido.indicaciones_paciente, pw - m * 2);
    for (const line of lines) {
      if (y > ph - 80) { doc.addPage(); y = m; }
      doc.text(line, m, y);
      y += 11;
    }
    y += 8;
  }

  // ── Footer en cada página ──
  const numPaginas = doc.internal.getNumberOfPages();
  for (let i = 1; i <= numPaginas; i++) {
    doc.setPage(i);
    const footerY = ph - 55;

    // Firma
    if (firmaImg) {
      doc.addImage(firmaImg, 'PNG', pw - m - 130, footerY - 30, 120, 60);
    }

    // Línea de firma
    doc.setDrawColor(180, 180, 180);
    doc.setLineWidth(0.5);
    doc.line(pw / 2 - 60, footerY + 10, pw - m, footerY + 10);

    // Nombre doctor + firma
    doc.setFontSize(8.5);
    doc.setTextColor(112, 112, 112);
    doc.setFont('helvetica', 'bold');
    doc.text('Dr. ', pw / 2 - 60, footerY + 22);
    doc.setTextColor(0, 0, 0);
    doc.text(dr.nombre, pw / 2 - 60 + doc.getTextWidth('Dr. ') + 2, footerY + 22);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(112, 112, 112);
    doc.text('  |  Firma:', pw / 2 - 60 + doc.getTextWidth('Dr. ') + 2 + doc.getTextWidth(dr.nombre), footerY + 22);

    // Paginación
    doc.setFontSize(8.5);
    doc.setTextColor(0, 0, 0);
    doc.setFont('helvetica', 'bold');
    doc.text(`pág ${i} - ${numPaginas}`, m, footerY + 22);
  }

  if (imprimir) {
    doc.autoPrint();
    window.open(doc.output('bloburl'), '_blank');
  } else {
    const nombre = (paciente?.nombre_completo || 'paciente').replace(/\s+/g, '_');
    doc.save(`orden_hospitalizacion_${nombre}_${Date.now()}.pdf`);
  }
}
